import { Link } from 'react-router-dom';
import { IoIosArrowDroprightCircle, IoIosArrowUp } from 'react-icons/io';
import { Divider, IconButton } from '@ds';
import { UnosIdButton } from '@ui';
import { getCaseSuffixes, getColorsByOrganType } from '@/utils/helpers';
import { useBaseCaseDetails } from '@/hooks/useBaseCaseDetails';

type CaseTitleProps = {
  showHospitals: boolean;
  onShowHospitals: () => void;
};

export const CaseTitle = ({ showHospitals, onShowHospitals }: CaseTitleProps) => {
  const {
    caseId,
    donorId,
    donorType,
    organType,
    reAllocationSequenceNumber,
    opoRequest,
    isExpeditedCase,
    laterality,
    duplicateCaseNumber,
  } = useBaseCaseDetails();
  const colors = getColorsByOrganType(organType);

  const caseSuffixes = getCaseSuffixes(
    organType,
    reAllocationSequenceNumber,
    opoRequest,
    isExpeditedCase,
    laterality,
    duplicateCaseNumber,
  );

  return (
    <div className="flex gap-2 items-center">
      <Link to={`/case/${caseId}`}>
        <IoIosArrowDroprightCircle size={24} />
      </Link>
      <h1 className={`${colors.text50} text-hl`}>{donorType}</h1>
      <Divider className="h-6" orientation="vertical" />
      <div className="flex items-center">
        <UnosIdButton
          suffixColor={colors.textDefault}
          caseSuffixes={caseSuffixes}
          donorId={donorId}
          containerClassName="text-3xl"
        />
        <IconButton
          size="md"
          variant="action"
          onPress={onShowHospitals}
          startContent={
            <div style={{ transform: `rotate(${showHospitals ? '0' : '180deg'})` }}>
              <IoIosArrowUp size={24} />
            </div>
          }
        />
      </div>
    </div>
  );
};
